import { formatReadableDate } from "utils/formatDate"

const TYPE_VARIANTS = {
  in: "success",
  inbound: "success",
  receive: "success",
  out: "primary",
  outbound: "primary",
  delivery: "primary",
  transfer: "info",
  workshop: "warning",
  service: "warning",
  "test drive": "secondary",
}

const variantFor = name =>
  TYPE_VARIANTS[String(name || "").trim().toLowerCase()] || "dark"

const MovementInfoCell = ({ data }) => {
  if (!data) {
    return <span className="text-muted">-</span>
  }

  const type = data.movement_type?.name || "Movement"
  const from = data.location_from?.name || "-"
  const to = data.location_to?.name || "-"
  const by = data.movement_by?.name || "-"
  const mileage = data.mileage
  const date = data.movement_date
    ? formatReadableDate(data.movement_date)
    : null

  return (
    <div style={{ minWidth: 240, maxWidth: 320 }}>
      <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
        <span className={`badge bg-${variantFor(type)}`}>{type}</span>
        {date && <small className="text-muted">{date}</small>}
      </div>

      <div className="d-flex align-items-center gap-1 fw-semibold mb-2">
        <span className="text-truncate" title={from}>
          {from}
        </span>
        <i className="bx bx-right-arrow-alt text-muted" />
        <span className="text-truncate" title={to}>
          {to}
        </span>
      </div>

      <div className="d-flex flex-wrap gap-3 text-muted small">
        <span>
          <i className="bx bx-user me-1" />
          {by}
        </span>
        <span>
          <i className="bx bx-tachometer me-1" />
          {mileage != null ? `${Number(mileage).toLocaleString()} km` : "-"}
        </span>
      </div>
    </div>
  )
}

export default MovementInfoCell
